interface LogoTitleProps {
    className?: string
}

export default function LogoTitle({ className = '' }: LogoTitleProps) {
    return (
        <img 
            src="/icon/logo.svg" 
            alt="Logo" 
            className={`w-28 ${className}`} 
        />
    )
}